import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const columnTextDefaultVariants = {}
const columnTextCompoundVariants = []

const columnTextSlotNames = [
  [
    "root",
    "column-text__root"
  ],
  [
    "contentWrapper",
    "column-text__contentWrapper"
  ],
  [
    "title",
    "column-text__title"
  ]
]
const columnTextSlotFns = /* @__PURE__ */ columnTextSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, columnTextDefaultVariants, getSlotCompoundVariant(columnTextCompoundVariants, slotName))])

const columnTextFn = memo((props = {}) => {
  return Object.fromEntries(columnTextSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const columnTextVariantKeys = []
const getVariantProps = (variants) => ({ ...columnTextDefaultVariants, ...compact(variants) })

export const columnText = /* @__PURE__ */ Object.assign(columnTextFn, {
  __recipe__: false,
  __name__: 'columnText',
  raw: (props) => props,
  variantKeys: columnTextVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, columnTextVariantKeys)
  },
  getVariantProps
})